export enum EPeriodoSolicitacaoDiaComerciario {
    NAO_CADASTRADO = 0,
    DENTRO_DO_PRAZO = 1,
    FORA_DO_PRAZO = 2,
}